/** Ícone do produto: copinho de iogurte com uma colher. Usa currentColor. */
export function CupIcon({ size = 20 }: { size?: number }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M5 8h14l-1.6 11.2a1.8 1.8 0 0 1-1.8 1.55H8.4a1.8 1.8 0 0 1-1.8-1.55Z" />
      <line x1="4.2" y1="8" x2="19.8" y2="8" />
      <ellipse cx="15.4" cy="4.4" rx="1.7" ry="2.4" />
      <line x1="15.4" y1="6.6" x2="12.7" y2="12.2" />
    </svg>
  );
}
